import { render, staticRenderFns } from "./Founders.vue?vue&type=template&id=2123d92b&"
import script from "./Founders.vue?vue&type=script&lang=ts&"
export * from "./Founders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports